import * as React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
} from "@/components/ui/sidebar";
import { companyInfo } from "@/config/constants";
import { navMain } from "@/config/menu";
import { NavMain } from "./nav-main";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <>
      <Sidebar collapsible="icon" {...props}>
        <SidebarHeader className="group-data-[collapsible=icon]:p-0">
          <div className="flex items-center gap-3 group-data-[collapsible=icon]:justify-center p-4 group-data-[collapsible=icon]:p-2">
            <div className="w-10 h-10 rounded-md bg-primary flex items-center justify-center shadow-lg group-data-[collapsible=icon]:w-8 transition-all duration-300">
              <svg
                width="20"
                height="13"
                viewBox="0 0 20 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.40741 0C0.630118 0 0 0.692893 0 1.54762V9.05357C0 11.2331 1.6068 13 3.58889 13L11.9259 12.9226C12.7032 12.9226 13.3333 12.2298 13.3333 11.375V3.79169C13.3333 1.61214 11.4265 2.68618e-05 9.44444 2.68618e-05L1.40741 0Z"
                  fill="white"
                />
                <path
                  d="M15.2358 2.9549C14.7328 3.43976 14.4444 4.13954 14.4444 4.87503V8.01591C14.4444 8.7514 14.7328 9.45118 15.2358 9.93604L18.3653 12.6235C19.0022 13.2374 20 12.7401 20 11.8089V1.22976C20 0.298508 19.0022 -0.198754 18.3654 0.415158L15.2358 2.9549Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="flex flex-col group-data-[collapsible=icon]:hidden transition-all duration-300">
              <h1 className="text-lg tracking-wide text-gray-600">
                <span className="text-primary font-bold text-xl">
                  {companyInfo.shortName}
                </span>
                meeting
              </h1>
              <p className="text-xs text-gray-500 font-medium">
                {companyInfo.description}
              </p>
            </div>
          </div>
        </SidebarHeader>
        <SidebarContent>
          <NavMain items={navMain} />
        </SidebarContent>

        {/* <SidebarRail /> */}
      </Sidebar>
    </>
  );
}
